/**
 * Force the window (and both common scrolling roots) to the top.
 * Useful after Auth → Dashboard layout swaps: `history.scrollRestoration`
 * can re-apply the scrolled declaration/login position onto the new layout.
 */
export function scrollWindowToTop(): void {
  // Drop focus first — iOS Safari often re-scrolls to keep a tapped control
  // (e.g. Agree) in view after an SPA navigation.
  const active = document.activeElement
  if (active instanceof HTMLElement && active !== document.body) {
    active.blur()
  }

  window.scrollTo({ top: 0, left: 0, behavior: 'auto' })
  document.documentElement.scrollTop = 0
  document.body.scrollTop = 0

  // VisualViewport can diverge from layout viewport on mobile browsers.
  if (window.visualViewport && window.visualViewport.offsetTop !== 0) {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' })
  }
}

/**
 * Scroll now, after paint, and again shortly after — beats late focus /
 * scroll-anchoring corrections that land after the first tick (common on
 * mobile once the welcome notification / Lottie paints).
 */
export function scrollWindowToTopSoon(): void {
  scrollWindowToTop()
  requestAnimationFrame(() => {
    scrollWindowToTop()
    requestAnimationFrame(scrollWindowToTop)
  })
  window.setTimeout(scrollWindowToTop, 50)
  window.setTimeout(scrollWindowToTop, 200)
  window.setTimeout(scrollWindowToTop, 500)
  window.setTimeout(scrollWindowToTop, 1000)
}
